import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const supportedLngs = ['en', 'es', 'ru', 'fr', 'pt', 'th', 'hi', 'vi'] as const;
export type SupportedLngs = (typeof supportedLngs)[number];
export const DEFAULT_LNG = 'en';
export const LS_LANG = 'lang';
export const APP_VERSION = '1.0.0';

// Получаем язык из localStorage или по умолчанию
const getLang = (): SupportedLngs => {
  const lsLang =
    typeof window !== 'undefined' ? (localStorage.getItem(LS_LANG) ?? '') : '';
  if (supportedLngs.includes(lsLang as SupportedLngs)) return lsLang as SupportedLngs;
  return DEFAULT_LNG as SupportedLngs;
};

export const applyFont = (lng: SupportedLngs) => {
  document.documentElement.setAttribute('data-lang', lng);
};

const initialLang = getLang();

if (typeof document !== 'undefined') {
  applyFont(initialLang);
}

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: getLang(),
    fallbackLng: DEFAULT_LNG,
    supportedLngs,
    ns: ['translation'],
    defaultNS: 'translation',
    debug: import.meta.env?.DEV ?? false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      // Файлы будут загружаться из public/locales/{lang}/{ns}
      loadPath: `/locales/{{lng}}/{{ns}}.json?ver=${APP_VERSION}`,
    },
  });

// Функция для смены языка и записи в localStorage
export const changeLanguage = (lng: SupportedLngs) => {
  i18n.changeLanguage(lng);
  if (typeof window !== 'undefined') {
    localStorage.setItem(LS_LANG, lng);
  }
};

export default i18n;
